export default __webpack_public_path__ + "static/media/ic_dot_96.8a301a42.svg";